import { Routes } from '@angular/router';

export const content: Routes = [
  {
    path: "sample-page",
    loadChildren: () => import("../../components/sample-page/sample-page.module").then((m) => m.SamplePageModule),
  },
  {
    path: "sample-page3",
    loadChildren: () => import("../../components/sample-page3/sample-page3.module").then((m) => m.SamplePage3Module),
  },
  {
    path: "empresa",
    loadChildren: () => import("../../components/empresa/empresa.module").then((m) => m.EmpresaModule),
  },
  {
    path: "empresa-dato-contacto",
    loadChildren: () => import("../../components/empresa-dato-contacto/empresa-dato-contacto.module").then((m) => m.EmpresaDatoContactoModule),
  },
  {
    path: "convenio",
    loadChildren: () => import("../../components/convenio/convenio.module").then((m) => m.ConvenioModule),
  },
  {
    path: "convenio-plaza",
    loadChildren: () => import("../../components/convenio-plaza/convenio-plaza.module").then((m) => m.ConvenioPlazaModule),
  },
  {
    path: "convenio-plaza-contacto",
    loadChildren: () => import("../../components/convenio-plaza-contacto/convenio-plaza-contacto.module").then((m) => m.ConvenioPlazaContactoModule),
  },
  {
    path: "convenio-plaza-reserva",
    loadChildren: () => import("../../components/convenio-plaza-reserva/convenio-plaza-reserva.module").then((m) => m.ConvenioPlazaReservaModule),
  },
  {
    path: "convenio-contacto",
    loadChildren: () => import("../../components/convenio-contacto/convenio-contacto.module").then((m) => m.ConvenioContactoModule),
  },
  {
    path: "seguridad",
    loadChildren: () => import("../../components/seguridad/seguridad.module").then((m) => m.SeguridadModule),
  },
  {
    path: "beneficiario-seguimiento",
    loadChildren: () => import("../../components/beneficiario-seguimiento/beneficiario-seguimiento.module").then((m) => m.BeneficiarioSeguimientoModule),
  },
  {
    path: "operacion",
    loadChildren: () => import("../../components/operacion/operacion.module").then((m) => m.OperacionModule),
  },
  {
    path: "reportes",
    loadChildren: () => import("../../components/reportes/reportes.module").then((m) => m.ReportesModule),
  }
  
];